/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/portfolio_analytics_medium'
export default icon
